import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';

function CollapseTransition({descriptiondata}) {
  const [open, setOpen] = useState(false);
  console.log("coindetaildat",descriptiondata);
  return (
    <>
      <Button onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        >Description</Button>
      <div  className="my-9">
      <Collapse in={open}><div id="example-collapse-text" className='w-full flex text-richblack-900 justify-around flex-col'>{descriptiondata}</div>
      </Collapse>
      </div>
    </>
  );
}

export default CollapseTransition;